import React from 'react';
import { SlapId } from '../utils/Primitives';
import { useServerSlapResourceCheck } from '../utils/useServerResourceCheck';
import type { ResourceCheckResult } from '../utils/useServerResourceCheck';

export interface SlapResourceTrackerProps {
  slapId: SlapId;
  onComplete?: (result: ResourceCheckResult) => void;
  onError?: (result: ResourceCheckResult) => void;
  onUpdate?: (result: ResourceCheckResult) => void;
}

export const SlapResourceTracker: React.FC<SlapResourceTrackerProps> = ({
  slapId,
  onComplete,
  onError,
  onUpdate
}) => {
  const { result } = useServerSlapResourceCheck(Number(slapId), {
    enabled: true,
    onComplete,
    onError
  });

  React.useEffect(() => {
    if (result && onUpdate) {
      onUpdate(result);
    }
  }, [result, onUpdate]);

  React.useEffect(() => {
    console.log('🎬 SlapResourceTracker mounted for slap', slapId);
  }, [slapId]);

  return null;
};

export interface MultiSlapResourceTrackerProps {
  slapIds: SlapId[];
  onSlapComplete?: (slapId: SlapId, result: ResourceCheckResult) => void;
  onSlapError?: (slapId: SlapId, result: ResourceCheckResult) => void;
  onSlapUpdate?: (slapId: SlapId, result: ResourceCheckResult) => void;
}

export const MultiSlapResourceTracker: React.FC<MultiSlapResourceTrackerProps> = ({
  slapIds,
  onSlapComplete,
  onSlapError,
  onSlapUpdate
}) => {
  return (
    <>
      {slapIds.map(slapId => (
        <SlapResourceTracker
          key={slapId}
          slapId={slapId}
          onComplete={
            onSlapComplete ? (r) => onSlapComplete(slapId, r) : undefined
          }
          onError={
            onSlapError ? (r) => onSlapError(slapId, r) : undefined
          }
          onUpdate={
            onSlapUpdate ? (r) => onSlapUpdate(slapId, r) : undefined
          }
        />
      ))}
    </>
  );
};


